import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { FaqAccordion } from "../components/FaqAccordion";
import { CtaBanner } from "../components/CtaBanner";
import { allFaqs, site } from "../config/siteConfig";

export default function FaqsPage() {
  return (
    <>
      <Seo
        title="FAQs | Ansar Public School Mundeke Goraya, Daska"
        description="Frequently asked questions about Ansar Public School Mundeke — admissions, classes, timings, curriculum, fees, location and contact."
      />
      <PageHero
        chapter="01"
        eyebrow="FAQs"
        title="Frequently Asked Questions"
        description="Answers use verified school information only. Anything still awaiting confirmation is clearly marked as an editable placeholder."
        crumb="FAQs"
      />

      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:py-20" data-testid="faqs-section">
        {allFaqs.map((group, gi) => (
          <div key={group.category} className={gi > 0 ? "mt-14" : ""}>
            <Reveal>
              <h2 className="mb-6 flex items-center gap-3 font-display text-2xl font-extrabold text-brand-ink">
                <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand text-sm font-bold text-white">
                  {String(gi + 1).padStart(2, "0")}
                </span>
                {group.category}
              </h2>
            </Reveal>
            <Reveal delay={0.08}>
              <FaqAccordion faqs={group.items} testIdPrefix={`faq-group-${gi}`} />
            </Reveal>
          </div>
        ))}
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:pb-24">
        <CtaBanner
          idPrefix="faqs-contact"
          title="Still Have a Question?"
          text="Call or message the school directly — the team is happy to help with admissions, timings, classes and anything else."
          primaryLabel="Send an Enquiry"
          primaryTo="/contact"
          secondaryLabel="Call the School"
          secondaryHref={site.phoneHref}
        />
      </section>
    </>
  );
}
